import moment from 'moment';

export const formDefaults = {
  all: {
    general: {
      mustHave: {
        grouped: false,
      },
      default: {
        search_pdfs: 'include',
        my_cases: '',
        case_titles: 'include',
      },
      omit: {
        party_name: null,
        nature_of_suit: null,
        chapter: null,
        case_type: null,
        business_cases: null,
        industry: null,
        assets: null,
        liabilities: null,
      },
    },
    cases: {
      mustHave: {
        grouped: true,
        search_pdfs: 'exclude',
        query: null,
      },
      default: {
        my_cases: '',
        case_titles: 'include',
        party_name: 'include',
      },
      omit: {
        nature_of_suit: null,
        chapter: null,
        case_type: null,
        business_cases: null,
        industry: null,
        assets: null,
        liabilities: null,
        date_doc_filed_from: null,
        date_doc_filed_to: null,
      },
    },
    'case-activity': {
      mustHave: {
        grouped: false,
        search_pdfs: 'exclude',
        my_cases: 'firm',
        query: ['dockets', 'claims'],
        date_doc_filed_from: moment(),
      },
      default: {
        case_titles: 'include',
      },
      omit: {
        party_name: null,
        nature_of_suit: null,
        chapter: null,
        case_type: null,
        business_cases: null,
        industry: null,
        assets: null,
        liabilities: null,
      },
    },
  },
  bankruptcy: {
    general: {
      mustHave: {
        grouped: false,
      },
      default: {
        search_pdfs: 'include',
        my_cases: '',
        case_titles: 'include',
        business_cases: 'include',
      },
      omit: {
        party_name: null,
        nature_of_suit: null,
      },
    },
    cases: {
      mustHave: {
        grouped: true,
        search_pdfs: 'exclude',
        query: null,
      },
      default: {
        my_cases: '',
        case_titles: 'include',
        business_cases: 'include',
        party_name: 'include',
      },
      omit: {
        nature_of_suit: null,
        date_doc_filed_from: null,
        date_doc_filed_to: null,
      },
    },
    petitions: {
      mustHave: {
        grouped: false,
        search_pdfs: 'exclude',
        query: ['docket_headers'],
        business_cases: 'limit',
      },
      default: {
        my_cases: '',
        case_titles: 'include',
      },
      omit: {
        party_name: null,
        nature_of_suit: null,
        date_closed_from: null,
        date_closed_to: null,
        date_dismissed_from: null,
        date_dismissed_to: null,
        date_discharged_from: null,
        date_discharged_to: null,
        date_doc_filed_from: null,
        date_doc_filed_to: null,
      },
    },
    schedules: {
      mustHave: {
        // grouped: false,
        query: null,
        business_cases: 'limit',
      },
      default: {
        search_pdfs: 'include',
        my_cases: '',
        case_titles: 'include',
      },
      omit: {
        party_name: null,
        nature_of_suit: null,
        date_closed_from: null,
        date_closed_to: null,
        date_dismissed_from: null,
        date_dismissed_to: null,
        date_discharged_from: null,
        date_discharged_to: null,
        date_doc_filed_from: null,
        date_doc_filed_to: null,
      },
    },
  },
  civil: {
    general: {
      mustHave: {
        grouped: false,
      },
      default: {
        search_pdfs: 'include',
        my_cases: '',
        case_titles: 'include',
      },
      omit: {
        party_name: null,
        chapter: null,
        case_type: null,
        business_cases: null,
        industry: null,
        assets: null,
        liabilities: null,
        date_dismissed_from: null,
        date_dismissed_to: null,
        date_discharged_from: null,
        date_discharged_to: null,
      },
    },
    cases: {
      mustHave: {
        grouped: true,
        search_pdfs: 'exclude',
        query: null,
      },
      default: {
        my_cases: '',
        case_titles: 'include',
        party_name: 'include',
      },
      omit: {
        chapter: null,
        case_type: null,
        business_cases: null,
        industry: null,
        assets: null,
        liabilities: null,
        date_dismissed_from: null,
        date_dismissed_to: null,
        date_discharged_from: null,
        date_discharged_to: null,
        date_doc_filed_from: null,
        date_doc_filed_to: null,
      },
    },
  },
  criminal: {
    general: {
      mustHave: {
        grouped: false,
      },
      default: {
        search_pdfs: 'include',
        my_cases: '',
        case_titles: 'include',
      },
      omit: {
        party_name: null,
        nature_of_suit: null,
        chapter: null,
        case_type: null,
        business_cases: null,
        industry: null,
        assets: null,
        liabilities: null,
        date_dismissed_from: null,
        date_dismissed_to: null,
        date_discharged_from: null,
        date_discharged_to: null,
      },
    },
    cases: {
      mustHave: {
        grouped: true,
        search_pdfs: 'exclude',
        query: null,
      },
      default: {
        my_cases: '',
        case_titles: 'include',
        party_name: 'include',
      },
      omit: {
        nature_of_suit: null,
        chapter: null,
        case_type: null,
        business_cases: null,
        industry: null,
        assets: null,
        liabilities: null,
        date_dismissed_from: null,
        date_dismissed_to: null,
        date_discharged_from: null,
        date_discharged_to: null,
        date_doc_filed_from: null,
        date_doc_filed_to: null,
      },
    },
  },
  appellate: {
    general: {
      mustHave: {
        grouped: false,
      },
      default: {
        search_pdfs: 'include',
        my_cases: '',
        case_titles: 'include',
      },
      omit: {
        party_name: null,
        nature_of_suit: null,
        chapter: null,
        case_type: null,
        business_cases: null,
        industry: null,
        assets: null,
        liabilities: null,
      },
    },
    cases: {
      mustHave: {
        grouped: true,
        search_pdfs: 'exclude',
        query: null,
      },
      default: {
        my_cases: '',
        case_titles: 'include',
        party_name: 'include',
      },
      omit: {
        nature_of_suit: null,
        chapter: null,
        case_type: null,
        business_cases: null,
        industry: null,
        assets: null,
        liabilities: null,
        date_doc_filed_from: null,
        date_doc_filed_to: null,
      },
    },
  },
};

export const scheduleSelectOptions = [
  { value: '', label: 'Select Schedule …' },
  { value: 'schedule_ab', label: 'Schedule A/B' },
  { value: 'schedule_d', label: 'Schedule D' },
  { value: 'schedule_ef', label: 'Schedule E/F' },
  { value: 'top20', label: 'Top Twenty' },
];

export const scheduleCategorySelectOptions = [
  { value: '', label: 'Select Category …' },
  { value: 'cash', label: 'Cash, cash equivalents, and financial assets' },
  { value: 'deposits', label: 'Deposits and prepayments' },
  { value: 'acct_rcpt', label: 'Accounts receivable' },
  { value: 'investments', label: 'Investments' },
  { value: 'inventory', label: 'Inventory' },
  { value: 'farming', label: 'Farming and fishing-related assets' },
  { value: 'office', label: 'Office furniture, fixtures, and equipment; and collectibles' },
  { value: 'machinery', label: 'Machinery, equipment, and vehicles' },
  { value: 'property', label: 'Real Property' },
  { value: 'intangibles', label: 'Intangibles and intellectual property' },
  { value: 'others', label: 'All other assets' },
  { value: 'personal_total', label: 'Personal total' },
  { value: 'real_total', label: 'Real total' },
  { value: 'total', label: 'Total of all property on Schedule A/B' },
];

export const limitSelectOptions = [
  { value: 'include', label: 'Include' },
  { value: 'exclude', label: 'Exclude' },
  { value: 'limit', label: 'Limit search to' },
];

export const casefoldersSelectOptions = [
  { value: '', label: 'Entire Database' },
  { value: 'user', label: 'My Casefolders' },
  { value: 'firm', label: 'Firm Casefolders' },
];

export const chapterSelectOptions = [
  { value: '7', label: '7' },
  { value: '9', label: '9' },
  { value: '11', label: '11' },
  { value: '12', label: '12' },
  { value: '13', label: '13' },
  { value: '15', label: '15' },
  { value: '304', label: '304' },
];

export const caseTypeSelectOptions = [
  { value: 'bk', label: 'Bankruptcy' },
  { value: 'ap', label: 'Adversary' },
  { value: 'mp', label: 'Miscellaneous' },
];

export const querySelectOptions = [
  { value: 'dockets', label: 'Docket' },
  { value: 'claims', label: 'Claims' },
  { value: 'creditors', label: 'Creditors' },
  { value: 'attorneys', label: 'Attorneys' },
  { value: 'history', label: 'Events' },
  { value: 'alias', label: 'Aliases' },
  { value: 'associated_cases', label: 'Associated Cases' },
  { value: 'case_summary', label: 'Summary' },
  { value: 'docket_headers', label: 'Docket Headers' },
  { value: 'claim_headers', label: 'Claim Headers' },
  { value: 'case_headers', label: 'Case Headers' },
  { value: 'creditor_mailing', label: 'Matrix' },
  { value: 'schedule', label: 'Deadlines' },
  { value: 'filers', label: 'Filers' },
  { value: 'notice', label: 'Notice' },
  { value: 'parties', label: 'Parties' },
  { value: 'related_transactions', label: 'Related' },
  { value: 'status_pending', label: 'Status' },
  { value: 'written_opinions', label: 'Written Opinions' },
];

export const regionSelectOptions = [
  { value: '01', label: 'First Circuit' },
  { value: '02', label: 'Second Circuit' },
  { value: '03', label: 'Third Circuit' },
  { value: '04', label: 'Fourth Circuit' },
  { value: '05', label: 'Fifth Circuit' },
  { value: '06', label: 'Sixth Circuit' },
  { value: '07', label: 'Seventh Circuit' },
  { value: '08', label: 'Eighth Circuit' },
  { value: '09', label: 'Ninth Circuit' },
  { value: '10', label: 'Tenth Circuit' },
  { value: '11', label: 'Eleventh Circuit' },
  { value: 'cafc', label: 'Federal Circuit' },
  { value: 'alm', label: 'Alabama Middle' },
  { value: 'aln', label: 'Alabama Northern' },
  { value: 'als', label: 'Alabama Southern' },
  { value: 'ak', label: 'Alaska' },
  { value: 'az', label: 'Arizona' },
  { value: 'are', label: 'Arkansas Eastern' },
  { value: 'arw', label: 'Arkansas Western' },
  { value: 'cac', label: 'California Central' },
  { value: 'cae', label: 'California Eastern' },
  { value: 'can', label: 'California Northern' },
  { value: 'cas', label: 'California Southern' },
  { value: 'co', label: 'Colorado' },
  { value: 'ct', label: 'Connecticut' },
  { value: 'dc', label: 'District of Columbia' },
  { value: 'de', label: 'Delaware' },
  { value: 'flm', label: 'Florida Middle' },
  { value: 'fln', label: 'Florida Northern' },
  { value: 'fls', label: 'Florida Southern' },
  { value: 'gam', label: 'Georgia Middle' },
  { value: 'gan', label: 'Georgia Northern' },
  { value: 'gas', label: 'Georgia Southern' },
  { value: 'gu', label: 'Guam' },
  { value: 'hi', label: 'Hawaii' },
  { value: 'id', label: 'Idaho' },
  { value: 'ilc', label: 'Illinois Central' },
  { value: 'iln', label: 'Illinois Northern' },
  { value: 'ils', label: 'Illinois Southern' },
  { value: 'inn', label: 'Indiana Northern' },
  { value: 'ins', label: 'Indiana Southern' },
  { value: 'ian', label: 'Iowa Northern' },
  { value: 'ias', label: 'Iowa Southern' },
  { value: 'ks', label: 'Kansas' },
  { value: 'kye', label: 'Kentucky Eastern' },
  { value: 'kyw', label: 'Kentucky Western' },
  { value: 'lae', label: 'Louisiana Eastern' },
  { value: 'lam', label: 'Louisiana Middle' },
  { value: 'law', label: 'Louisiana Western' },
  { value: 'me', label: 'Maine' },
  { value: 'md', label: 'Maryland' },
  { value: 'ma', label: 'Massachusetts' },
  { value: 'mie', label: 'Michigan Eastern' },
  { value: 'miw', label: 'Michigan Western' },
  { value: 'mn', label: 'Minnesota' },
  { value: 'msn', label: 'Mississippi Northern' },
  { value: 'mss', label: 'Mississippi Southern' },
  { value: 'moe', label: 'Missouri Eastern' },
  { value: 'mow', label: 'Missouri Western' },
  { value: 'mt', label: 'Montana' },
  { value: 'ne', label: 'Nebraska' },
  { value: 'nv', label: 'Nevada' },
  { value: 'nh', label: 'New Hampshire' },
  { value: 'nj', label: 'New Jersey' },
  { value: 'nm', label: 'New Mexico' },
  { value: 'nye', label: 'New York Eastern' },
  { value: 'nyn', label: 'New York Northern' },
  { value: 'nys', label: 'New York Southern' },
  { value: 'nyw', label: 'New York Western' },
  { value: 'nce', label: 'North Carolina Eastern' },
  { value: 'ncm', label: 'North Carolina Middle' },
  { value: 'ncw', label: 'North Carolina Western' },
  { value: 'nd', label: 'North Dakota' },
  { value: 'nmi', label: 'Northern Mariana Islands' },
  { value: 'ohn', label: 'Ohio Northern' },
  { value: 'ohs', label: 'Ohio Southern' },
  { value: 'oke', label: 'Oklahoma Eastern' },
  { value: 'okn', label: 'Oklahoma Northern' },
  { value: 'okw', label: 'Oklahoma Western' },
  { value: 'or', label: 'Oregon' },
  { value: 'pae', label: 'Pennsylvania Eastern' },
  { value: 'pam', label: 'Pennsylvania Middle' },
  { value: 'paw', label: 'Pennsylvania Western' },
  { value: 'pr', label: 'Puerto Rico' },
  { value: 'ri', label: 'Rhode Island' },
  { value: 'sc', label: 'South Carolina' },
  { value: 'sd', label: 'South Dakota' },
  { value: 'tne', label: 'Tennessee Eastern' },
  { value: 'tnm', label: 'Tennessee Middle' },
  { value: 'tnw', label: 'Tennessee Western' },
  { value: 'txe', label: 'Texas Eastern' },
  { value: 'txn', label: 'Texas Northern' },
  { value: 'txs', label: 'Texas Southern' },
  { value: 'txw', label: 'Texas Western' },
  { value: 'ut', label: 'Utah' },
  { value: 'vt', label: 'Vermont' },
  { value: 'vi', label: 'Virgin Islands' },
  { value: 'vae', label: 'Virginia Eastern' },
  { value: 'vaw', label: 'Virginia Western' },
  { value: 'wae', label: 'Washington Eastern' },
  { value: 'waw', label: 'Washington Western' },
  { value: 'wvn', label: 'West Virginia Northern' },
  { value: 'wvs', label: 'West Virginia Southern' },
  { value: 'wie', label: 'Wisconsin Eastern' },
  { value: 'wiw', label: 'Wisconsin Western' },
  { value: 'wy', label: 'Wyoming' },
];

export const industrySelectOptions = [
  { value: '11', label: '11 Agriculture, Forestry, Fishing and Hunting' },
  { value: '111', label: '- 111 Crop Production' },
  { value: '1112', label: '- - 1112 Vegetable and Melon Farming' },
  { value: '1113', label: '- - 1113 Fruit and Tree Nut Farming' },
  { value: '1114', label: '- - 1114 Greenhouse, Nursery, and Floriculture Production' },
  { value: '1119', label: '- - 1119 Other Crop Farming' },
  { value: '112', label: '- 112 Animal Production and Aquaculture' },
  { value: '1121', label: '- - 1121 Cattle Ranching and Farming' },
  { value: '1122', label: '- - 1122 Hog and Pig Farming' },
  { value: '1123', label: '- - 1123 Poultry and Egg Production' },
  { value: '1124', label: '- - 1124 Sheep and Goat Farming' },
  { value: '1125', label: '- - 1125 Aquaculture' },
  { value: '1129', label: '- - 1129 Other Animal Production' },
  { value: '113', label: '- 113 Forestry and Logging' },
  { value: '1131', label: '- - 1131 Timber Tract Operations' },
  { value: '1132', label: '- - 1132 Forest Nurseries and Gathering of Forest Products' },
  { value: '1133', label: '- - 1133 Logging' },
  { value: '114', label: '- 114 Fishing, Hunting and Trapping' },
  { value: '1141', label: '- - 1141 Fishing' },
  { value: '1142', label: '- - 1142 Hunting and Trapping' },
  { value: '115', label: '- 115 Support Activities for Agriculture and Forestry' },
  { value: '1151', label: '- - 1151 Support Activities for Crop Production' },
  { value: '1152', label: '- - 1152 Support Activities for Animal Production' },
  { value: '1153', label: '- - 1153 Support Activities for Forestry' },
  { value: '21', label: '21 Mining, Quarrying, and Oil and Gas Extraction' },
  { value: '211', label: '- 211 Oil and Gas Extraction' },
  { value: '2111', label: '- - 2111 Oil and Gas Extraction' },
  { value: '212', label: '- 212 Mining (except Oil and Gas)' },
  { value: '2121', label: '- - 2121 Coal Mining' },
  { value: '2122', label: '- - 2122 Metal Ore Mining' },
  { value: '2123', label: '- - 2123 Nonmetallic Mineral Mining and Quarrying' },
  { value: '213', label: '- 213 Support Activities for Mining' },
  { value: '2131', label: '- - 2131 Support Activities for Mining' },
  { value: '22', label: '22 Utilities' },
  { value: '221', label: '- 221 Utilities' },
  { value: '2211', label: '- - 2211 Electric Power Generation, Transmission and Distribution' },
  { value: '2212', label: '- - 2212 Natural Gas Distribution' },
  { value: '2213', label: '- - 2213 Water, Sewage and Other Systems' },
  { value: '23', label: '23 Construction' },
  { value: '236', label: '- 236 Construction of Buildings' },
  { value: '2361', label: '- - 2361 Residential Building Construction' },
  { value: '2362', label: '- - 2362 Nonresidential Building Construction' },
  { value: '237', label: '- 237 Heavy and Civil Engineering Construction' },
  { value: '2371', label: '- - 2371 Utility System Construction' },
  { value: '2372', label: '- - 2372 Land Subdivision' },
  { value: '2373', label: '- - 2373 Highway, Street, and Bridge Construction' },
  { value: '2379', label: '- - 2379 Other Heavy and Civil Engineering Construction' },
  { value: '238', label: '- 238 Specialty Trade Contractors' },
  { value: '2381', label: '- - 2381 Foundation, Structure, and Building Exterior Contractors' },
  { value: '2382', label: '- - 2382 Building Equipment Contractors' },
  { value: '2383', label: '- - 2383 Building Finishing Contractors' },
  { value: '2389', label: '- - 2389 Other Specialty Trade Contractors' },
  { value: '31', label: '31 Construction' },
  { value: '311', label: '- 311 Food Manufacturing' },
  { value: '3111', label: '- - 3111 Animal Food Manufacturing' },
  { value: '3112', label: '- - 3112 Grain and Oilseed Milling' },
  { value: '3113', label: '- - 3113 Sugar and Confectionery Product Manufacturing' },
  { value: '3114', label: '- - 3114 Fruit and Vegetable Preserving and Specialty Food Manufacturing' },
  { value: '3115', label: '- - 3115 Dairy Product Manufacturing' },
  { value: '3116', label: '- - 3116 Animal Slaughtering and Processing' },
  { value: '3117', label: '- - 3117 Seafood Product Preparation and Packaging' },
  { value: '3118', label: '- - 3118 Bakeries and Tortilla Manufacturing' },
  { value: '3119', label: '- - 3119 Other Food Manufacturing' },
  { value: '312', label: '- 312 Beverage and Tobacco Product Manufacturing' },
  { value: '3121', label: '- - 3121 Beverage Manufacturing' },
  { value: '3122', label: '- - 3122 Tobacco Manufacturing' },
  { value: '313', label: '- 313 Textile Mills' },
  { value: '3131', label: '- - 3131 Fiber, Yarn, and Thread Mills' },
  { value: '3132', label: '- - 3132 Fabric Mills' },
  { value: '3133', label: '- - 3133 Textile and Fabric Finishing and Fabric Coating Mills' },
  { value: '314', label: '- 314 Textile Product Mills' },
  { value: '3141', label: '- - 3141 Textile Furnishings Mills' },
  { value: '3149', label: '- - 3149 Other Textile Product Mills' },
  { value: '315', label: '- 315 Apparel Manufacturing' },
  { value: '3151', label: '- - 3151 Apparel Knitting Mills' },
  { value: '3152', label: '- - 3152 Cut and Sew Apparel Manufacturing' },
  { value: '3159', label: '- - 3159 Apparel Accessories and Other Apparel Manufacturing' },
  { value: '316', label: '- 316 Leather and Allied Product Manufacturing' },
  { value: '3161', label: '- - 3161 Leather and Hide Tanning and Finishing' },
  { value: '3162', label: '- - 3162 Footwear Manufacturing' },
  { value: '3169', label: '- - 3169 Other Leather and Allied Product Manufacturing' },
  { value: '32', label: '32 Construction' },
  { value: '321', label: '- 321 Wood Product Manufacturing' },
  { value: '3211', label: '- - 3211 Sawmills and Wood Preservation' },
  { value: '3212', label: '- - 3212 Veneer, Plywood, and Engineered Wood Product Manufacturing' },
  { value: '3219', label: '- - 3219 Other Wood Product Manufacturing' },
  { value: '322', label: '- 322 Paper Manufacturing' },
  { value: '3221', label: '- - 3221 Pulp, Paper, and Paperboard Mills' },
  { value: '3222', label: '- - 3222 Converted Paper Product Manufacturing' },
  { value: '323', label: '- 323 Printing and Related Support Activities' },
  { value: '3231', label: '- - 3231 Printing and Related Support Activities' },
  { value: '324', label: '- 324 Petroleum and Coal Products Manufacturing' },
  { value: '3241', label: '- - 3241 Petroleum and Coal Products Manufacturing' },
  { value: '325', label: '- 325 Chemical Manufacturing' },
  { value: '3251', label: '- - 3251 Basic Chemical Manufacturing' },
  {
    value: '3252',
    label: '- - 3252 Resin, Synthetic Rubber, and Artificial Synthetic Fibers and Filaments Manufacturing',
  },
  { value: '3253', label: '- - 3253 Pesticide, Fertilizer, and Other Agricultural Chemical Manufacturing' },
  { value: '3254', label: '- - 3254 Pharmaceutical and Medicine Manufacturing' },
  { value: '3255', label: '- - 3255 Paint, Coating, and Adhesive Manufacturing' },
  { value: '3256', label: '- - 3256 Soap, Cleaning Compound, and Toilet Preparation Manufacturing' },
  { value: '3259', label: '- - 3259 Other Chemical Product and Preparation Manufacturing' },
  { value: '326', label: '- 326 Plastics and Rubber Products Manufacturing' },
  { value: '3261', label: '- - 3261 Plastics Product Manufacturing' },
  { value: '3262', label: '- - 3262 Rubber Product Manufacturing' },
  { value: '327', label: '- 327 Nonmetallic Mineral Product Manufacturing' },
  { value: '3271', label: '- - 3271 Clay Product and Refractory Manufacturing' },
  { value: '3272', label: '- - 3272 Glass and Glass Product Manufacturing' },
  { value: '3273', label: '- - 3273 Cement and Concrete Product Manufacturing' },
  { value: '3274', label: '- - 3274 Lime and Gypsum Product Manufacturing' },
  { value: '3279', label: '- - 3279 Other Nonmetallic Mineral Product Manufacturing' },
  { value: '33', label: '33 Construction' },
  { value: '331', label: '- 331 Primary Metal Manufacturing' },
  { value: '3311', label: '- - 3311 Iron and Steel Mills and Ferroalloy Manufacturing' },
  { value: '3312', label: '- - 3312 Steel Product Manufacturing from Purchased Steel' },
  { value: '3313', label: '- - 3313 Alumina and Aluminum Production and Processing' },
  { value: '3314', label: '- - 3314 Nonferrous Metal (except Aluminum) Production and Processing' },
  { value: '3315', label: '- - 3315 Foundries' },
  { value: '332', label: '- 332 Fabricated Metal Product Manufacturing' },
  { value: '3321', label: '- - 3321 Forging and Stamping' },
  { value: '3322', label: '- - 3322 Cutlery and Handtool Manufacturing' },
  { value: '3323', label: '- - 3323 Architectural and Structural Metals Manufacturing' },
  { value: '3324', label: '- - 3324 Boiler, Tank, and Shipping Container Manufacturing' },
  { value: '3325', label: '- - 3325 Hardware Manufacturing' },
  { value: '3326', label: '- - 3326 Spring and Wire Product Manufacturing' },
  { value: '3327', label: '- - 3327 Machine Shops; Turned Product; and Screw, Nut, and Bolt Manufacturing' },
  { value: '3328', label: '- - 3328 Coating, Engraving, Heat Treating, and Allied Activities' },
  { value: '3329', label: '- - 3329 Other Fabricated Metal Product Manufacturing' },
  { value: '333', label: '- 333 Machinery Manufacturing' },
  { value: '3331', label: '- - 3331 Agriculture, Construction, and Mining Machinery Manufacturing' },
  { value: '3332', label: '- - 3332 Industrial Machinery Manufacturing' },
  { value: '3333', label: '- - 3333 Commercial and Service Industry Machinery Manufacturing' },
  {
    value: '3334',
    label: '- - 3334 Ventilation, Heating, Air-Conditioning, and Commercial Refrigeration Equipment Manufacturing',
  },
  { value: '3335', label: '- - 3335 Metalworking Machinery Manufacturing' },
  { value: '3336', label: '- - 3336 Engine, Turbine, and Power Transmission Equipment Manufacturing' },
  { value: '3339', label: '- - 3339 Other General Purpose Machinery Manufacturing' },
  { value: '334', label: '- 334 Computer and Electronic Product Manufacturing' },
  { value: '3341', label: '- - 3341 Computer and Peripheral Equipment Manufacturing' },
  { value: '3342', label: '- - 3342 Communications Equipment Manufacturing' },
  { value: '3343', label: '- - 3343 Audio and Video Equipment Manufacturing' },
  { value: '3344', label: '- - 3344 Semiconductor and Other Electronic Component Manufacturing' },
  { value: '3345', label: '- - 3345 Navigational, Measuring, Electromedical, and Control Instruments Manufacturing' },
  { value: '3346', label: '- - 3346 Manufacturing and Reproducing Magnetic and Optical Media' },
  { value: '335', label: '- 335 Electrical Equipment, Appliance, and Component Manufacturing' },
  { value: '3351', label: '- - 3351 Electric Lighting Equipment Manufacturing' },
  { value: '3352', label: '- - 3352 Household Appliance Manufacturing' },
  { value: '3353', label: '- - 3353 Electrical Equipment Manufacturing' },
  { value: '3359', label: '- - 3359 Other Electrical Equipment and Component Manufacturing' },
  { value: '336', label: '- 336 Transportation Equipment Manufacturing' },
  { value: '3361', label: '- - 3361 Motor Vehicle Manufacturing' },
  { value: '3362', label: '- - 3362 Motor Vehicle Body and Trailer Manufacturing' },
  { value: '3363', label: '- - 3363 Motor Vehicle Parts Manufacturing' },
  { value: '3364', label: '- - 3364 Aerospace Product and Parts Manufacturing' },
  { value: '3365', label: '- - 3365 Railroad Rolling Stock Manufacturing' },
  { value: '3366', label: '- - 3366 Ship and Boat Building' },
  { value: '3369', label: '- - 3369 Other Transportation Equipment Manufacturing' },
  { value: '337', label: '- 337 Furniture and Related Product Manufacturing' },
  { value: '3371', label: '- - 3371 Household and Institutional Furniture and Kitchen Cabinet Manufacturing' },
  { value: '3372', label: '- - 3372 Office Furniture (including Fixtures) Manufacturing' },
  { value: '3379', label: '- - 3379 Other Furniture Related Product Manufacturing' },
  { value: '339', label: '- 339 Miscellaneous Manufacturing' },
  { value: '3391', label: '- - 3391 Medical Equipment and Supplies Manufacturing' },
  { value: '3399', label: '- - 3399 Other Miscellaneous Manufacturing' },
  { value: '42', label: '42 Wholesale Trade' },
  { value: '423', label: '- 423 Merchant Wholesalers, Durable Goods' },
  { value: '4231', label: '- - 4231 Motor Vehicle and Motor Vehicle Parts and Supplies Merchant Wholesalers' },
  { value: '4232', label: '- - 4232 Furniture and Home Furnishing Merchant Wholesalers' },
  { value: '4233', label: '- - 4233 Lumber and Other Construction Materials Merchant Wholesalers' },
  { value: '4234', label: '- - 4234 Professional and Commercial Equipment and Supplies Merchant Wholesalers' },
  { value: '4235', label: '- - 4235 Metal and Mineral (except Petroleum) Merchant Wholesalers' },
  { value: '4236', label: '- - 4236 Household Appliances and Electrical and Electronic Goods Merchant Wholesalers' },
  { value: '4237', label: '- - 4237 Hardware, and Plumbing and Heating Equipment and Supplies Merchant Wholesalers' },
  { value: '4238', label: '- - 4238 Machinery, Equipment, and Supplies Merchant Wholesalers' },
  { value: '4239', label: '- - 4239 Miscellaneous Durable Goods Merchant Wholesalers' },
  { value: '424', label: '- 424 Merchant Wholesalers, Nondurable Goods' },
  { value: '4241', label: '- - 4241 Paper and Paper Product Merchant Wholesalers' },
  { value: '4242', label: "- - 4242 Drugs and Druggists' Sundries Merchant Wholesalers" },
  { value: '4243', label: '- - 4243 Apparel, Piece Goods, and Notions Merchant Wholesalers' },
  { value: '4244', label: '- - 4244 Grocery and Related Product Merchant Wholesalers' },
  { value: '4245', label: '- - 4245 Farm Product Raw Material Merchant Wholesalers' },
  { value: '4246', label: '- - 4246 Chemical and Allied Products Merchant Wholesalers' },
  { value: '4247', label: '- - 4247 Petroleum and Petroleum Products Merchant Wholesalers' },
  { value: '4248', label: '- - 4248 Beer, Wine, and Distilled Alcoholic Beverage Merchant Wholesalers' },
  { value: '4249', label: '- - 4249 Miscellaneous Nondurable Goods Merchant Wholesalers' },
  { value: '425', label: '- 425 Wholesale Electronic Markets and Agents and Brokers' },
  { value: '4251', label: '- - 4251 Wholesale Electronic Markets and Agents and Brokers' },
  { value: '44', label: '44 Wholesale Trade' },
  { value: '441', label: '- 441 Motor Vehicle and Parts Dealers' },
  { value: '4411', label: '- - 4411 Automobile Dealers' },
  { value: '4412', label: '- - 4412 Other Motor Vehicle Dealers' },
  { value: '4413', label: '- - 4413 Automotive Parts, Accessories, and Tire Stores' },
  { value: '442', label: '- 442 Furniture and Home Furnishings Stores' },
  { value: '4421', label: '- - 4421 Furniture Stores' },
  { value: '4422', label: '- - 4422 Home Furnishings Stores' },
  { value: '443', label: '- 443 Electronics and Appliance Stores' },
  { value: '4431', label: '- - 4431 Electronics and Appliance Stores' },
  { value: '444', label: '- 444 Building Material and Garden Equipment and Supplies Dealers' },
  { value: '4441', label: '- - 4441 Building Material and Supplies Dealers' },
  { value: '4442', label: '- - 4442 Lawn and Garden Equipment and Supplies Stores' },
  { value: '445', label: '- 445 Food and Beverage Stores' },
  { value: '4451', label: '- - 4451 Grocery Stores' },
  { value: '4452', label: '- - 4452 Specialty Food Stores' },
  { value: '4453', label: '- - 4453 Beer, Wine, and Liquor Stores' },
  { value: '446', label: '- 446 Health and Personal Care Stores' },
  { value: '4461', label: '- - 4461 Health and Personal Care Stores' },
  { value: '447', label: '- 447 Gasoline Stations' },
  { value: '4471', label: '- - 4471 Gasoline Stations' },
  { value: '448', label: '- 448 Clothing and Clothing Accessories Stores' },
  { value: '4481', label: '- - 4481 Clothing Stores' },
  { value: '4482', label: '- - 4482 Shoe Stores' },
  { value: '4483', label: '- - 4483 Jewelry, Luggage, and Leather Goods Stores' },
  { value: '45', label: '45 Wholesale Trade' },
  { value: '451', label: '- 451 Sporting Goods, Hobby, Musical Instrument, and Book Stores' },
  { value: '4511', label: '- - 4511 Sporting Goods, Hobby, and Musical Instrument Stores' },
  { value: '4512', label: '- - 4512 Book Stores and News Dealers' },
  { value: '452', label: '- 452 General Merchandise Stores' },
  { value: '4521', label: '- - 4521 Department Stores' },
  { value: '4529', label: '- - 4529 Other General Merchandise Stores' },
  { value: '453', label: '- 453 Miscellaneous Store Retailers' },
  { value: '4531', label: '- - 4531 Florists' },
  { value: '4532', label: '- - 4532 Office Supplies, Stationery, and Gift Stores' },
  { value: '4533', label: '- - 4533 Used Merchandise Stores' },
  { value: '4539', label: '- - 4539 Other Miscellaneous Store Retailers' },
  { value: '454', label: '- 454 Nonstore Retailers' },
  { value: '4541', label: '- - 4541 Electronic Shopping and Mail-Order Houses' },
  { value: '4542', label: '- - 4542 Vending Machine Operators' },
  { value: '4543', label: '- - 4543 Direct Selling Establishments' },
  { value: '48', label: '48 Wholesale Trade' },
  { value: '481', label: '- 481 Air Transportation' },
  { value: '4811', label: '- - 4811 Scheduled Air Transportation' },
  { value: '4812', label: '- - 4812 Nonscheduled Air Transportation' },
  { value: '482', label: '- 482 Rail Transportation' },
  { value: '4821', label: '- - 4821 Rail Transportation' },
  { value: '483', label: '- 483 Water Transportation' },
  { value: '4831', label: '- - 4831 Deep Sea, Coastal, and Great Lakes Water Transportation' },
  { value: '4832', label: '- - 4832 Inland Water Transportation' },
  { value: '484', label: '- 484 Truck Transportation' },
  { value: '4841', label: '- - 4841 General Freight Trucking' },
  { value: '4842', label: '- - 4842 Specialized Freight Trucking' },
  { value: '485', label: '- 485 Transit and Ground Passenger Transportation' },
  { value: '4851', label: '- - 4851 Urban Transit Systems' },
  { value: '4852', label: '- - 4852 Interurban and Rural Bus Transportation' },
  { value: '4853', label: '- - 4853 Taxi and Limousine Service' },
  { value: '4854', label: '- - 4854 School and Employee Bus Transportation' },
  { value: '4855', label: '- - 4855 Charter Bus Industry' },
  { value: '4859', label: '- - 4859 Other Transit and Ground Passenger Transportation' },
  { value: '486', label: '- 486 Pipeline Transportation' },
  { value: '4861', label: '- - 4861 Pipeline Transportation of Crude Oil' },
  { value: '4862', label: '- - 4862 Pipeline Transportation of Natural Gas' },
  { value: '4869', label: '- - 4869 Other Pipeline Transportation' },
  { value: '487', label: '- 487 Scenic and Sightseeing Transportation' },
  { value: '4871', label: '- - 4871 Scenic and Sightseeing Transportation, Land' },
  { value: '4872', label: '- - 4872 Scenic and Sightseeing Transportation, Water' },
  { value: '4879', label: '- - 4879 Scenic and Sightseeing Transportation, Other' },
  { value: '488', label: '- 488 Support Activities for Transportation' },
  { value: '4881', label: '- - 4881 Support Activities for Air Transportation' },
  { value: '4882', label: '- - 4882 Support Activities for Rail Transportation' },
  { value: '4883', label: '- - 4883 Support Activities for Water Transportation' },
  { value: '4884', label: '- - 4884 Support Activities for Road Transportation' },
  { value: '4885', label: '- - 4885 Freight Transportation Arrangement' },
  { value: '4889', label: '- - 4889 Other Support Activities for Transportation' },
  { value: '49', label: '49 Wholesale Trade' },
  { value: '491', label: '- 491 Postal Service' },
  { value: '4911', label: '- - 4911 Postal Service' },
  { value: '492', label: '- 492 Couriers and Messengers' },
  { value: '4921', label: '- - 4921 Couriers and Express Delivery Services' },
  { value: '4922', label: '- - 4922 Local Messengers and Local Delivery' },
  { value: '493', label: '- 493 Warehousing and Storage' },
  { value: '4931', label: '- - 4931 Warehousing and Storage' },
  { value: '51', label: '51 Information' },
  { value: '511', label: '- 511 Publishing Industries (except Internet)' },
  { value: '5111', label: '- - 5111 Newspaper, Periodical, Book, and Directory Publishers' },
  { value: '5112', label: '- - 5112 Software Publishers' },
  { value: '512', label: '- 512 Motion Picture and Sound Recording Industries' },
  { value: '5121', label: '- - 5121 Motion Picture and Video Industries' },
  { value: '5122', label: '- - 5122 Sound Recording Industries' },
  { value: '515', label: '- 515 Broadcasting (except Internet)' },
  { value: '5151', label: '- - 5151 Radio and Television Broadcasting' },
  { value: '5152', label: '- - 5152 Cable and Other Subscription Programming' },
  { value: '517', label: '- 517 Telecommunications' },
  { value: '5171', label: '- - 5171 Wired Telecommunications Carriers' },
  { value: '5172', label: '- - 5172 Wireless Telecommunications Carriers (except Satellite)' },
  { value: '5174', label: '- - 5174 Satellite Telecommunications' },
  { value: '5179', label: '- - 5179 Other Telecommunications' },
  { value: '518', label: '- 518 Data Processing, Hosting, and Related Services' },
  { value: '5182', label: '- - 5182 Data Processing, Hosting, and Related Services' },
  { value: '519', label: '- 519 Other Information Services' },
  { value: '5191', label: '- - 5191 Other Information Services' },
  { value: '52', label: '52 Finance and Insurance' },
  { value: '521', label: '- 521 Monetary Authorities-Central Bank' },
  { value: '5211', label: '- - 5211 Monetary Authorities-Central Bank' },
  { value: '522', label: '- 522 Credit Intermediation and Related Activities' },
  { value: '5221', label: '- - 5221 Depository Credit Intermediation' },
  { value: '5222', label: '- - 5222 Nondepository Credit Intermediation' },
  { value: '5223', label: '- - 5223 Activities Related to Credit Intermediation' },
  {
    value: '523',
    label: '- 523 Securities, Commodity Contracts, and Other Financial Investments and Related Activities',
  },
  { value: '5231', label: '- - 5231 Securities and Commodity Contracts Intermediation and Brokerage' },
  { value: '5232', label: '- - 5232 Securities and Commodity Exchanges' },
  { value: '5239', label: '- - 5239 Other Financial Investment Activities' },
  { value: '524', label: '- 524 Insurance Carriers and Related Activities' },
  { value: '5241', label: '- - 5241 Insurance Carriers' },
  { value: '5242', label: '- - 5242 Agencies, Brokerages, and Other Insurance Related Activities' },
  { value: '525', label: '- 525 Funds, Trusts, and Other Financial Vehicles' },
  { value: '5251', label: '- - 5251 Insurance and Employee Benefit Funds' },
  { value: '5259', label: '- - 5259 Other Investment Pools and Funds' },
  { value: '53', label: '53 Real Estate and Rental and Leasing' },
  { value: '531', label: '- 531 Real Estate' },
  { value: '5311', label: '- - 5311 Lessors of Real Estate' },
  { value: '5312', label: '- - 5312 Offices of Real Estate Agents and Brokers' },
  { value: '5313', label: '- - 5313 Activities Related to Real Estate' },
  { value: '532', label: '- 532 Rental and Leasing Services' },
  { value: '5321', label: '- - 5321 Automotive Equipment Rental and Leasing' },
  { value: '5322', label: '- - 5322 Consumer Goods Rental' },
  { value: '5323', label: '- - 5323 General Rental Centers' },
  { value: '5324', label: '- - 5324 Commercial and Industrial Machinery and Equipment Rental and Leasing' },
  { value: '533', label: '- 533 Lessors of Nonfinancial Intangible Assets (except Copyrighted Works)' },
  { value: '5331', label: '- - 5331 Lessors of Nonfinancial Intangible Assets (except Copyrighted Works)' },
  { value: '54', label: '54 Professional, Scientific, and Technical Services' },
  { value: '541', label: '- 541 Professional, Scientific, and Technical Services' },
  { value: '5411', label: '- - 5411 Legal Services' },
  { value: '5412', label: '- - 5412 Accounting, Tax Preparation, Bookkeeping, and Payroll Services' },
  { value: '5413', label: '- - 5413 Architectural, Engineering, and Related Services' },
  { value: '5414', label: '- - 5414 Specialized Design Services' },
  { value: '5415', label: '- - 5415 Computer Systems Design and Related Services' },
  { value: '5416', label: '- - 5416 Management, Scientific, and Technical Consulting Services' },
  { value: '5417', label: '- - 5417 Scientific Research and Development Services' },
  { value: '5418', label: '- - 5418 Advertising, Public Relations, and Related Services' },
  { value: '5419', label: '- - 5419 Other Professional, Scientific, and Technical Services' },
  { value: '55', label: '55 Management of Companies and Enterprises' },
  { value: '551', label: '- 551 Management of Companies and Enterprises' },
  { value: '5511', label: '- - 5511 Management of Companies and Enterprises' },
  { value: '56', label: '56 Administrative and Support and Waste Management and Remediation Services' },
  { value: '561', label: '- 561 Administrative and Support Services' },
  { value: '5611', label: '- - 5611 Office Administrative Services' },
  { value: '5612', label: '- - 5612 Facilities Support Services' },
  { value: '5613', label: '- - 5613 Employment Services' },
  { value: '5614', label: '- - 5614 Business Support Services' },
  { value: '5615', label: '- - 5615 Travel Arrangement and Reservation Services' },
  { value: '5616', label: '- - 5616 Investigation and Security Services' },
  { value: '5617', label: '- - 5617 Services to Buildings and Dwellings' },
  { value: '5619', label: '- - 5619 Other Support Services' },
  { value: '562', label: '- 562 Waste Management and Remediation Services' },
  { value: '5621', label: '- - 5621 Waste Collection' },
  { value: '5622', label: '- - 5622 Waste Treatment and Disposal' },
  { value: '5629', label: '- - 5629 Remediation and Other Waste Management Services' },
  { value: '61', label: '61 Educational Services' },
  { value: '611', label: '- 611 Educational Services' },
  { value: '6111', label: '- - 6111 Elementary and Secondary Schools' },
  { value: '6112', label: '- - 6112 Junior Colleges' },
  { value: '6113', label: '- - 6113 Colleges, Universities, and Professional Schools' },
  { value: '6114', label: '- - 6114 Business Schools and Computer and Management Training' },
  { value: '6115', label: '- - 6115 Technical and Trade Schools' },
  { value: '6116', label: '- - 6116 Other Schools and Instruction' },
  { value: '6117', label: '- - 6117 Educational Support Services' },
  { value: '62', label: '62 Health Care and Social Assistance' },
  { value: '621', label: '- 621 Ambulatory Health Care Services' },
  { value: '6211', label: '- - 6211 Offices of Physicians' },
  { value: '6212', label: '- - 6212 Offices of Dentists' },
  { value: '6213', label: '- - 6213 Offices of Other Health Practitioners' },
  { value: '6214', label: '- - 6214 Outpatient Care Centers' },
  { value: '6215', label: '- - 6215 Medical and Diagnostic Laboratories' },
  { value: '6216', label: '- - 6216 Home Health Care Services' },
  { value: '6219', label: '- - 6219 Other Ambulatory Health Care Services' },
  { value: '622', label: '- 622 Hospitals' },
  { value: '6221', label: '- - 6221 General Medical and Surgical Hospitals' },
  { value: '6222', label: '- - 6222 Psychiatric and Substance Abuse Hospitals' },
  { value: '6223', label: '- - 6223 Specialty (except Psychiatric and Substance Abuse) Hospitals' },
  { value: '623', label: '- 623 Nursing and Residential Care Facilities' },
  { value: '6231', label: '- - 6231 Nursing Care Facilities (Skilled Nursing Facilities)' },
  {
    value: '6232',
    label:
      '- - 6232 Residential Intellectual and Developmental Disability, Mental Health, and Substance Abuse Facilities',
  },
  {
    value: '6233',
    label: '- - 6233 Continuing Care Retirement Communities and Assisted Living Facilities for the Elderly',
  },
  { value: '6239', label: '- - 6239 Other Residential Care Facilities' },
  { value: '624', label: '- 624 Social Assistance' },
  { value: '6241', label: '- - 6241 Individual and Family Services' },
  { value: '6242', label: '- - 6242 Community Food and Housing, and Emergency and Other Relief Services' },
  { value: '6243', label: '- - 6243 Vocational Rehabilitation Services' },
  { value: '6244', label: '- - 6244 Child Day Care Services' },
  { value: '71', label: '71 Arts, Entertainment, and Recreation' },
  { value: '711', label: '- 711 Performing Arts, Spectator Sports, and Related Industries' },
  { value: '7111', label: '- - 7111 Performing Arts Companies' },
  { value: '7112', label: '- - 7112 Spectator Sports' },
  { value: '7113', label: '- - 7113 Promoters of Performing Arts, Sports, and Similar Events' },
  {
    value: '7114',
    label: '- - 7114 Agents and Managers for Artists, Athletes, Entertainers, and Other Public Figures',
  },
  { value: '7115', label: '- - 7115 Independent Artists, Writers, and Performers' },
  { value: '712', label: '- 712 Museums, Historical Sites, and Similar Institutions' },
  { value: '7121', label: '- - 7121 Museums, Historical Sites, and Similar Institutions' },
  { value: '713', label: '- 713 Amusement, Gambling, and Recreation Industries' },
  { value: '7131', label: '- - 7131 Amusement Parks and Arcades' },
  { value: '7132', label: '- - 7132 Gambling Industries' },
  { value: '7139', label: '- - 7139 Other Amusement and Recreation Industries' },
  { value: '72', label: '72 Accommodation and Food Services' },
  { value: '721', label: '- 721 Accommodation' },
  { value: '7211', label: '- - 7211 Traveler Accommodation' },
  { value: '7212', label: '- - 7212 RV (Recreational Vehicle) Parks and Recreational Camps' },
  { value: '7213', label: '- - 7213 Rooming and Boarding Houses' },
  { value: '722', label: '- 722 Food Services and Drinking Places' },
  { value: '7223', label: '- - 7223 Special Food Services' },
  { value: '7224', label: '- - 7224 Drinking Places (Alcoholic Beverages)' },
  { value: '7225', label: '- - 7225 Restaurants and Other Eating Places' },
  { value: '81', label: '81 Other Services (except Public Administration)' },
  { value: '811', label: '- 811 Repair and Maintenance' },
  { value: '8111', label: '- - 8111 Automotive Repair and Maintenance' },
  { value: '8112', label: '- - 8112 Electronic and Precision Equipment Repair and Maintenance' },
  {
    value: '8113',
    label:
      '- - 8113 Commercial and Industrial Machinery and Equipment (except Automotive and Electronic) Repair and Maintenance',
  },
  { value: '8114', label: '- - 8114 Personal and Household Goods Repair and Maintenance' },
  { value: '812', label: '- 812 Personal and Laundry Services' },
  { value: '8121', label: '- - 8121 Personal Care Services' },
  { value: '8122', label: '- - 8122 Death Care Services' },
  { value: '8123', label: '- - 8123 Drycleaning and Laundry Services' },
  { value: '8129', label: '- - 8129 Other Personal Services' },
  { value: '813', label: '- 813 Religious, Grantmaking, Civic, Professional, and Similar Organizations' },
  { value: '8131', label: '- - 8131 Religious Organizations' },
  { value: '8132', label: '- - 8132 Grantmaking and Giving Services' },
  { value: '8133', label: '- - 8133 Social Advocacy Organizations' },
  { value: '8134', label: '- - 8134 Civic and Social Organizations' },
  { value: '8139', label: '- - 8139 Business, Professional, Labor, Political, and Similar Organizations' },
  { value: '814', label: '- 814 Private Households' },
  { value: '8141', label: '- - 8141 Private Households' },
  { value: '92', label: '92 Public Administration' },
  { value: '921', label: '- 921 Executive, Legislative, and Other General Government Support' },
  { value: '9211', label: '- - 9211 Executive, Legislative, and Other General Government Support' },
  { value: '922', label: '- 922 Justice, Public Order, and Safety Activities' },
  { value: '9221', label: '- - 9221 Justice, Public Order, and Safety Activities' },
  { value: '923', label: '- 923 Administration of Human Resource Programs' },
  { value: '9231', label: '- - 9231 Administration of Human Resource Programs' },
  { value: '924', label: '- 924 Administration of Environmental Quality Programs' },
  { value: '9241', label: '- - 9241 Administration of Environmental Quality Programs' },
  { value: '925', label: '- 925 Administration of Housing Programs, Urban Planning, and Community Development' },
  { value: '9251', label: '- - 9251 Administration of Housing Programs, Urban Planning, and Community Development' },
  { value: '926', label: '- 926 Administration of Economic Programs' },
  { value: '9261', label: '- - 9261 Administration of Economic Programs' },
  { value: '927', label: '- 927 Space Research and Technology' },
  { value: '9271', label: '- - 9271 Space Research and Technology' },
  { value: '928', label: '- 928 National Security and International Affairs' },
  { value: '9281', label: '- - 9281 National Security and International Affairs' },
];

export const assetsLiabilitiesSelectOptions = [
  { value: 'Unknown', label: 'Unknown' },
  { value: '$0 to $50,000', label: '$0 to $50,000' },
  { value: '$50,001 to $100,000', label: '$50,001 to $100,000' },
  { value: '$100,001 to $500,000', label: '$100,001 to $500,000' },
  { value: '$500,001 to $1 million', label: '$500,001 to $1 million' },
  { value: '$1,000,001 to $10 million', label: '$1,000,001 to $10 million' },
  { value: '$10,000,001 to $50 million', label: '$10,000,001 to $50 million' },
  { value: '$50,000,001 to $100 million', label: '$50,000,001 to $100 million' },
  { value: '$100,000,001 to $500 million', label: '$100,000,001 to $500 million' },
  { value: '$500,000,001 to $1 billion', label: '$500,000,001 to $1 billion' },
  { value: 'More than $1 billion', label: 'More than $1 billion' },
  { value: '$1,000,000,001 to $10 billion', label: '$1,000,000,001 to $10 billion' },
  { value: '$10,000,000,001 to $50 billion', label: '$10,000,000,001 to $50 billion' },
  { value: 'More than $50 billion', label: 'More than $50 billion' },
];



// WEBPACK FOOTER //
// ./src/components/advancedSearch/formData.js